import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import RightSideDetailsPanel from "./rightSideDetailsPanel";
const mapDispatchToProps = (dispatch) => ({
    onSetPanelWidth: (width) => dispatch(actionCreators.setPanelWidth(width))
});
export default connect(undefined, mapDispatchToProps)(RightSideDetailsPanel);
